import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_LICENSED_STATES_ACTION_TYPE } from '../actions';

const initialState = { loadError: null };

const subCompanyNmlsLicensesStatusReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.GET_NMLS_STATES:
        draft.loadError = null;
        break;

      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.GET_NMLS_STATES_FAILURE:
        draft.loadError = payload;
        break;

      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyNmlsLicensesStatusReducer;
